document.addEventListener("DOMContentLoaded", function () {
  const faqSection = document.querySelector(".faq-section");
  const tabs = document.querySelectorAll(".faq-tab");
  const categories = document.querySelectorAll(".faq-category");
  const filterToggle = document.querySelector(".faq-filter-toggle");

  const searchInput = document.querySelector(".faq-search-input");

  // MOBILE DROPDOWN ELEMENTS
  const mobileDropdown = document.querySelector(".faq-mobile-dropdown");
  const mobileTrigger = mobileDropdown
    ? mobileDropdown.querySelector(".faq-mobile-trigger")
    : null;
  const mobileTriggerMain = mobileDropdown
    ? mobileDropdown.querySelector(".faq-mobile-trigger-main")
    : null;
  const mobileOptions = mobileDropdown
    ? mobileDropdown.querySelectorAll(".faq-mobile-option")
    : [];

  /* -----------------------------
     Helper: activate tab + content
  ----------------------------- */
  function activateByTabId(tabId) {
    if (!tabId) return;

    // Right side content: faq-category
    categories.forEach((cat) => {
      cat.classList.toggle("active", cat.id === tabId);
    });

    // Left side tabs
    tabs.forEach((tab) => {
      const tId = tab.getAttribute("data-tab");
      tab.classList.toggle("active", tId === tabId);
    });

    // Mobile dropdown: update active option + trigger label/icon
    if (mobileDropdown && mobileTriggerMain && mobileOptions.length) {
      let matchedOption = null;

      mobileOptions.forEach((opt) => {
        const oId = opt.getAttribute("data-tab");
        const isMatch = oId === tabId;
        opt.classList.toggle("is-active", isMatch);
        if (isMatch) matchedOption = opt;
      });

      // fallback to first option
      if (!matchedOption) {
        matchedOption = mobileOptions[0];
      }

      if (matchedOption) {
        // Trigger ke andar sirf MAIN part (icon + text) replace karo
        mobileTriggerMain.innerHTML = matchedOption.innerHTML;
      }
    }
  }

  /* -----------------------------
     1. TAB CLICK (desktop + tablet)
  ----------------------------- */
  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const tabId = tab.getAttribute("data-tab");
      activateByTabId(tabId);
    });
  });

  /* -----------------------------
     1b. MOBILE DROPDOWN
  ----------------------------- */
  if (mobileDropdown && mobileTrigger) {
    // Initial: active tab se trigger fill karo
    const activeTab =
      document.querySelector(".faq-tab.active") || tabs[0] || null;
    if (activeTab) {
      activateByTabId(activeTab.getAttribute("data-tab"));
    }

    // Trigger click → open / close list
    mobileTrigger.addEventListener("click", function () {
      mobileDropdown.classList.toggle("is-open");
    });

    // Option click → category switch + close dropdown
    mobileOptions.forEach((opt) => {
      opt.addEventListener("click", function () {
        const tabId = this.getAttribute("data-tab");
        activateByTabId(tabId);
        mobileDropdown.classList.remove("is-open");
      });
    });
  }

  /* -----------------------------
     2. FAQ ACCORDION
  ----------------------------- */
  document.querySelectorAll(".faq-question").forEach((q) => {
    const ans = q.nextElementSibling;
    const item = q.closest(".faq-item");

    // sab start me band
    ans.style.maxHeight = "0px";

    q.addEventListener("click", () => {
      const isOpen = q.classList.contains("active");

      if (isOpen) {
        q.classList.remove("active");
        ans.style.maxHeight = "0px";
        if (item) item.classList.remove("is-open");
      } else {
        q.classList.add("active");
        ans.style.maxHeight = ans.scrollHeight + "px";
        if (item) item.classList.add("is-open");
      }
    });
  });

  /* -----------------------------
     3. MOBILE FILTER TOGGLE
     (sirf jab mobile_layout = "filter" ho,
      CSS hi show/hide handle karega)
  ----------------------------- */
  if (filterToggle && faqSection) {
    filterToggle.addEventListener("click", () => {
      faqSection.classList.toggle("tabs-open");

      const isOpen = faqSection.classList.contains("tabs-open");
      filterToggle.innerHTML = isOpen ? "Close" : "Filter";
    });
  }

  /* -----------------------------
     4. SEARCH – only active category
  ----------------------------- */
  if (searchInput) {
    searchInput.addEventListener("input", function () {
      const query = this.value.toLowerCase().trim();

      const activeIndex = [...tabs].findIndex((tab) =>
        tab.classList.contains("active"),
      );
      if (activeIndex === -1) return;

      const activeCategory = categories[activeIndex];
      const faqItems = activeCategory.querySelectorAll(".faq-item");

      if (query === "") {
        faqItems.forEach((item) => (item.style.display = "block"));
        return;
      }

      faqItems.forEach((item) => {
        const q = item
          .querySelector(".faq-question span")
          .textContent.toLowerCase();
        const a = item.querySelector(".faq-answer").textContent.toLowerCase();

        if (q.includes(query) || a.includes(query)) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      });
    });
  }
});

/* -----------------------------
   EMAIL LINKER (same as before)
----------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  var answers = document.querySelectorAll(".faq-answer");

  answers.forEach(function (answer) {
    if (answer.dataset.emailsLinked === "true") return;

    var html = answer.innerHTML;

    html = html.replace(
      /(?![^<]*>)([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
      '<a href="mailto:$1">$1</a>',
    );

    answer.innerHTML = html;
    answer.dataset.emailsLinked = "true";
  });
});
